import React from "react";

import JobPage from "./JobPage";

const JuniorLegalAnalyst = () => (
    <JobPage
        title="Junior Legal Analyst"
        location="Malta (On-site)"
        type="Full-time"
        posted="2026-05-29"
        overview={[
            "Everest.org is seeking a sharp, detail-oriented Junior Legal Analyst to join our team in Malta. In this role, you will be at the intersection of traditional financial services and the evolving digital-asset landscape. You will support our legal and compliance teams in navigating the complexities of the Markets in Crypto-Assets (MiCA) regulation, blockchain infrastructure, and cross-border payment operations.",
            "This is an ideal position for a candidate who is passionate about fintech law and eager to build deep expertise within a high-growth, regulated environment.",
        ]}
        summary={[
            {
                title: "Regulatory analysis",
                text: "Monitor and interpret emerging EU and local regulations, with a primary focus on MiCA compliance, VFA Act requirements, and payment-services legislation.",
            },
            {
                title: "Compliance support",
                text: "Assist in preparing and reviewing documentation for regulatory filings, license applications, and internal policy audits.",
            },
            {
                title: "Legal research",
                text: "Conduct thorough research on blockchain-related legal precedents, crypto-asset classification, and AML/CFT standards to support senior counsel.",
            },
            {
                title: "Contract review",
                text: "Assist in drafting and reviewing commercial agreements, service-level agreements (SLAs), and operational disclosures related to payment flows and crypto-asset services.",
            },
            {
                title: "Cross-functional collaboration",
                text: "Work closely with our technical and operations teams to ensure business logic and internal processes remain aligned with current regulatory obligations.",
            },
            {
                title: "Reporting",
                text: "Prepare memoranda and briefings on regulatory updates for internal stakeholders and management committees.",
            },
        ].map((r) => (
            <>
                <strong>{r.title}</strong> — {r.text}
            </>
        ))}
        requirements={[
            <>
                <strong>Education</strong> — Bachelor's or Master's degree in
                Law, Finance, or a related field (NQF Level 6 or equivalent).
            </>,
            <>
                <strong>Language skills</strong> — Full professional proficiency
                in English and Czech (both written and spoken) is mandatory.
            </>,
            <>
                <strong>Regulatory knowledge</strong> — Solid understanding of,
                or a strong academic interest in, the Markets in Crypto-Assets
                (MiCA) regulation, the Financial Institutions Act, and broader
                European financial-services legislation.
            </>,
            <>
                <strong>Domain interest</strong> — Genuine curiosity about
                blockchain technology, digital payments (SEPA / SWIFT), and the
                mechanics of crypto-asset service providers (CASPs).
            </>,
            <>
                <strong>Analytical mindset</strong> — Exceptional attention to
                detail, strong organizational skills, and the ability to
                synthesize complex regulatory documents into actionable
                insights.
            </>,
            <>
                <strong>Residency</strong> — Must be eligible to work in Malta.
            </>,
        ]}
        whyJoin={[
            {
                title: "Frontline fintech",
                text: "Engage with cutting-edge developments in the crypto and digital-payments space from one of Europe's premier fintech hubs.",
            },
            {
                title: "Mentorship",
                text: "Hands-on exposure to high-level compliance strategy and regulatory engagement.",
            },
            {
                title: "Dynamic environment",
                text: "A collaborative, tech-forward culture focused on innovation and institutional-grade integrity.",
            },
        ]}
        showValues={false}
        showAbout={false}
        applyInstructions={
            <>
                Please submit your CV and a brief cover letter in English
                outlining your interest in fintech law and your relevant
                experience to{" "}
                <a
                    href="mailto:contact@everest.org?subject=Everest Careers — Junior Legal Analyst"
                    style={{ color: "#fff", textDecoration: "underline" }}
                >
                    contact@everest.org
                </a>
                .
            </>
        }
    />
);

export default JuniorLegalAnalyst;
